import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/presupuesto/importer/presupuestoImporterActions';

export default importerReducers(actions);
